namespace $.$$ {
	export class $shm_mentionstat_items extends $.$shm_mentionstat_items {
		body_rows() {
			return [
				this.item_ids().length ? this.Grid() : this.Empty(),
				this.Controls(),
			]
		}

		columns() {
			return [ 'Запрос', 'Минус-слова', 'Период', 'Страна', 'Язык', 'Соцмедиа', 'СМИ', 'Тип', 'Теги', 'Категория', '' ]
		}

		records() {
			return this.item_ids().map( id => [ id ] )
		}

		col_ids() {
			return this.columns().map( ( _, index )=> String( index ) )
		}

		col_head_content( id: string ) {
			return [ this.columns()[ Number( id ) ] ?? '' ]
		}

		col_width( id: string ) {
			return [ '170px', '150px', '180px', '120px', '100px', '160px', '160px', '120px', '140px', '140px', '88px' ][ Number( id ) ] ?? '160px'
		}

		cell_width( id: { row: string[], col: string } ) {
			return this.col_width( id.col )
		}

		cell_content( id: { row: string[], col: string } ) {
			const row = this.records()[ Number( id.row[ id.row.length - 1 ] ) ]
			const item = String( row?.[0] || '' )
			if( !item ) return []
			const values = [
				this.item_query( item ), this.item_excluded( item ), this.item_period( item ),
				this.item_country( item ), this.item_language( item ), this.item_social( item ),
				this.item_mass( item ), this.item_type( item ), this.item_tags( item ), this.item_category( item ),
			]
			if( Number( id.col ) === values.length ) return [ this.Actions( item ) ]
			return [ String( values[ Number( id.col ) ] ?? '' ) ]
		}
	}
}
